import React from "react";

const SendSmsEmailConext = React.createContext({});
export { SendSmsEmailConext };
